/**
 * @generated SignedSource<<102eb4152f175917832ee18b6935aae1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary$data = {
  readonly acceptedTimeAverageInMs: number | null;
  readonly " $fragmentType": "WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary";
};
export type WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary$key = {
  readonly " $data"?: WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "acceptedTimeAverageInMs",
      "storageKey": null
    }
  ],
  "type": "IntegrationTurnpikeSummary",
  "abstractKey": null
};

(node as any).hash = "72dc6226905d41bf5b143bf2342727ab";

export default node;
